import { FC } from 'react'
import { Box, CircularProgress } from '@mui/material'
import { ThemeButton } from 'ui/components/buttons'

interface Props {
  backLabel: string
  nextLabel: string
  nextDisabled?: boolean
  submitting?: boolean
  onBack: () => void
  onNext: () => void
}

/* The wizard's only actions: the steps themselves carry no apply buttons. */
const WizardFooter: FC<Props> = ({ backLabel, nextLabel, nextDisabled, submitting, onBack, onNext }) => (
  <Box className="form-footer">
    <ThemeButton themevariant="secondary" shape="rectangular" type="button" onClick={onBack}>
      {backLabel}
    </ThemeButton>

    <ThemeButton
      themevariant="primary"
      shape="rectangular"
      type="button"
      onClick={onNext}
      disabled={nextDisabled}
      startIcon={submitting ? <CircularProgress size="20px" /> : undefined}
    >
      {nextLabel}
    </ThemeButton>
  </Box>
)

export default WizardFooter
